import React from "react";
// ANT DESIGN COMPONENTS
import { Card, List } from "antd";
// FONT AWESOME LIBRARY AND ICONS
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendar } from "@fortawesome/free-solid-svg-icons";

export default function DashboardVersion() {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */
	const v117 = [
		"• Reports / save in memory bank id selected",
		"• Reports / save in memory server id selected",
		"• Adapters / assign keys / offsts / delete value null",
	];
	const v118 = [
		"• Edge management / Adapters / Create new adapter / CDO Modbus",
		"• Dashboard / Overview / Versions",
		"• Organization management / Users / User actions / Actions enabled for user status OFFLINE CREATED",
	];

	// ************************************************ */
	// USE STATE VARIABLES **************************** */

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */

	// ************************************************ */
	// CUSTOM HOOKS *********************************** */

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */

	// ************************************************ */
	// FUNCTIONS ************************************** */

	// ************************************************ */
	// USE EFFECT ************************************* */

	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<div className='generalStyles__dashboardCardContainer'>
			<Card
				loading={false}
				hoverable
				className='generalStyles__dashboardCardXL'
				title={
					<div>
						<FontAwesomeIcon icon={faCalendar} className='generalStyles__info generalStyles__mrFix' />
						<span>August 18 / 2025</span>
					</div>
				}
				style={{ margin: "10px" }}
			>
				<List size='small' bordered={false} dataSource={v117} renderItem={(item) => <List.Item>{item}</List.Item>} />{" "}
			</Card>
			<Card
				loading={false}
				hoverable
				className='generalStyles__dashboardCardXXL'
				title={
					<div>
						<FontAwesomeIcon icon={faCalendar} className='generalStyles__info generalStyles__mrFix' />
						<span>August 22 / 2025</span>
					</div>
				}
				style={{ margin: "10px" }}
			>
				<List size='small' bordered={false} dataSource={v118} renderItem={(item) => <List.Item>{item}</List.Item>} />{" "}
			</Card>
		</div>
	);
}
